module.exports = __webpack_public_path__ + "img/dashboard.4af1821c.svg";